export const initialAddTestValues = {
    isSubmitEnabled: false,
      open: false,
      existingTest: false,
      scheduledTest: true,
      check: true,
      scheduledTests: [],
      scheduledTestsNames: [],
      errorMessage: {},
      errorText: '',
      errorBool: false,
      errors: {
        testName: '',
        testSyllabus: '',
        maxAttempt: '',
        questionsCount: '',
        blockRevisionTime: '',
        duration: '',
        goal: '',
        scheduleDate: '',
        scheduleEndDate: '',
        mappedTestValid:''
      },
      regexp: /^[0-9\b]+$/,
      selectedTest: {
        paperDetail: {
          syllabus: '',
          id: '',
          name: '',
          type: '',
          testType: '',
          duration: '',
          status: '',
          codeName: '',
          displayName: '',
          scheduleID: '',
          scheduleDate: '',
          startTime: '',
          scheduleEndDate: '',
          endTime: '',
          maxAttempt: '',
          blockRevisionTime: '',
          // _id:''
        },
        testType: '',
        duration: '',
        status: '',
        codeName: '',
        displayName: '',
        scheduleID: '',
        scheduleDate: '',
        startTime: '',
        scheduleEndDate: '',
        endTime: '',
        maxAttempt: '',
        questionsCount: 0,
        blockRevisionTime: 0,
        _id: '',
        courseId: '',
      },
      isTestMapped: false,
      mapTestSuggestions: [],
      mapTestSuggestionNames: [],
      coursesByScheduleId: [],
      preparedCourseData: [],
      activeGoals: [],
      overAllData: {},
      startDate: '',
      endDate: '',
      goalsDriller: {},
      courseId: '',
      mapScheduleTest: [],
      selectOptions: [],
      mapTestName: '',
      selectTouch: false,
      phaseBool: false,
}